import React, { useState, useContext } from "react";
import { Button, Flex, Form, Input, theme, Result } from "antd";
import { IdcardOutlined } from "@ant-design/icons";
import { captureException } from "@sentry/react";
import useHttpClient from "/src/hooks/useHttpClient";
import { isPhoneNumberValid } from "/src/utils/digits";
import OtpModal from "./OTPModal";
import { filterToDigits } from "/src/utils/digits";
import { getErrorMessage } from "/src/utils/http";
import { AppContext } from "/src/constants/contexts";

function GetInfo({
  phoneNumber = "",
  onUpdate,
  title = "تکمیل اطلاعات",
  subTitle = "شماره همراه شما ثبت نشده است، لطفا جهت ادامه شماره همراه خود را ثبت کنید.",
}) {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { messageApi } = useContext(AppContext);
  const httpClient = useHttpClient();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  form.setFieldsValue({ phoneNumber });
  function handleUpdateInfo() {
    setLoading(true);
    httpClient
      .put("/users/me/phone", {...form.getFieldsValue(), disableOtp: true})
      .then(() => {
        onUpdate();
        messageApi.open({
          type: "success",
          content: "شماره همراه با موفقیت ثبت شد",
        });
      })
      .catch((error) => {
        captureException(error);
        const errorMessage = getErrorMessage(error, "خطا در ثبت شماره همراه");
        messageApi.open({
          type: "error",
          content: errorMessage,
        });
      })
      .finally(() => setLoading(false));
  }

  return (
    <>
      <Flex className="h-full" align="center" justify="center">
        <Result
          className={`rounded-2xl block p-6  border-none w-fit`}
          style={{
            backgroundColor: colorBgContainer,
            boxShadow: "rgb(0 0 0 / 11%) 0px 0px 10px 0px",
          }}
          icon={<IdcardOutlined />}
          status="error"
          title={title}
          subTitle={!phoneNumber ? subTitle : "لطفا برای ادامه شماره همراه خود را تایید کنید."}
          extra={[
            <Flex align="center" justify="center">
              <Form
                layout="vertical"
                style={{ width: 200 }}
                onFinish={handleUpdateInfo}
                form={form}
                variant='filled'
              >
                <Form.Item
                  label="شماره همراه"
                  name="phoneNumber"
                  rules={[
                    { required: true, message: "این فیلد ضروری است" },
                    {
                      message: "شماره همراه معتبر نیست",
                      validator: (_, value) =>
                        !isPhoneNumberValid(value) ? Promise.reject() : Promise.resolve(),
                    },
                  ]}
                >
                  <Input style={{ direction: "ltr" }} />
                </Form.Item>
                <Button
                  // icon={<YoutubeFilled style={{ fontSize: 25 }} />}
                  htmlType="submit"
                  size="large"
                  // onClick={handleUpdateInfo}
                  style={{ width: "100%" }}
                  type="primary"
                  loading={loading}
                  disabled={loading}
                >
                  ثبت
                </Button>
              </Form>
            </Flex>,
          ]}
        />
      </Flex>
    </>
  );
}

export default GetInfo;
